export default {
  dashboard: '/dashboard',
  alerts: '/alerts',
  residents: '/residents',
  healthcareProviders: '/healthcare-providers',
  healthcareProviderGroups: '/healthcare-provider-groups',
  configuration: '/configuration',
  hcpGroups: '/hcp-groups',
  sites: '/sites',
  deviceHealth: '/device-health',
  deviceOverview: '/device-overview',
  statistics: '/statistics',
  firmware: '/firmware',
};
